import React from "react"
import Text from "~/ui/typography"
import { Tag } from "~/ui/tag"

interface TagData {
  id: string
  name: string
}

interface HeaderWithTableFiltersProps {
  title: string
  subtitle: string
  selectedTags: string[]
  allTags: TagData[]
  onTagRemove: (tagId: string) => void
  onClearAll: () => void
}

export function HeaderWithTableFilters({
  title,
  subtitle,
  selectedTags,
  allTags,
  onTagRemove,
  onClearAll,
}: HeaderWithTableFiltersProps) {
  const getSelectedTagNames = () => {
    return selectedTags
      .map((tagId) => allTags.find((tag) => tag.id === tagId)?.name)
      .filter(Boolean)
  }

  return (
    <div className="grid gap-2">
      <div className="flex items-center gap-3">
        <Text as="h1" variant="heading3_medium">
          {title}
        </Text>
      </div>
      <Text as="p" variant="subheader">
        {subtitle}
      </Text>
      {selectedTags.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {getSelectedTagNames().map((tagName, index) => (
            <Tag
              key={index}
              selected={true}
              onRemove={() => {
                const tagToRemove = allTags.find((tag) => tag.name === tagName)
                if (tagToRemove) {
                  onTagRemove(tagToRemove.id)
                }
              }}
            >
              {tagName}
            </Tag>
          ))}
          <button
            type="button"
            onClick={onClearAll}
            className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 hover:bg-gray-100"
          >
            Clear all
          </button>
        </div>
      )}
    </div>
  )
}
